import { filterObjecttypes } from 'cadenza/attribute-util';
import { getAttributeById, getVisibleObjecttypes } from 'cadenza/workbook/workbook.state';
import { store } from 'cadenza/store/cadenza-store';

/**
 * Filter all ObjectTypes available in the workbook with the given controller.
 *
 * @param {AttributeListController} controller - The controller used for filtering
 * @return {ObjectType[]} Returns a deeply filtered list of ObjectTypes. If an ObjectType does not
 *     have any attribute left it is removed.
 */
export function filterAllObjectTypes (controller) {
  const visibleObjectTypes = resolveObjecttypeAttributes(getVisibleObjecttypes(store.getState()));
  return filterObjecttypes(
    visibleObjectTypes,
    { attributePredicate: attribute => controller.accepts(attribute).accepts });
}

export function resolveObjecttypeAttributes (objectTypes) {
  return objectTypes.map(objectType => {
    return {
      ...objectType,
      attributes: objectType.attributes
        .map(attributeOrId => typeof attributeOrId === 'string'
          ? getAttributeById(store.getState(), attributeOrId)
          : attributeOrId)
        .filter(attribute => attribute.visible)
    };
  });
}

function getAttribute (attributeOrId) {
  return (typeof attributeOrId === 'string')
    ? getAttributeById(store.getState(), attributeOrId)
    : attributeOrId;
}

/**
 * Check if thw two attribute or attribute ids given refer
 * to the same base attribute.
 *
 * @param {string|object} a - first attribute
 * @param {string|object} b - second attribute
 * @return {boolean} <code>true</code> if a and b refer to the same base attribute
 * (or one of them is a base attribute and the other is an active attribute based on it).
 */
export function isSameBaseAttribute (a, b) {
  const { id: aId, baseId: aBaseId = aId } = getAttribute(a);
  const { id: bId, baseId: bBaseId = bId } = getAttribute(b);
  return (aBaseId === bBaseId);
}
